export default __webpack_public_path__ + "images/0xb785ee8752b8bf3b0c8d9857f24b491e8c0a3d92.png";